/**
 * Checks if value does not match ("!==") the comparison.
 * @param value The value being checked.
 * @param target The target value to perform the check against.
 * @return True if the value does not equal the target, false otherwise.
 */
export function isNotEqualTo(value: any, target: any): boolean {
    return value !== target;
  }
  